import { BackendSocket } from '../../hooks/use-socket';
import { SubscriberContext } from '../../hooks/use-backend';
import { account, meta, next } from '../../stores/backend';
import { InBuyCards } from '../../types/bingo-events/in/backend/buy-cards';

export const onBuyCards = (
    socket: BackendSocket,
    { payload, postBalanceChange }: SubscriberContext
) => {
    const callback = (response: InBuyCards) => {
        if (response.success) {
            const { data } = response;
            account.set({
                wagered: data.wagered,
                player_cash: data.player_cash,
                player_bonus: data.player_bonus,
                player_fp_balance: Math.max(
                    0,
                    (account.player_fp_balance.value || 0) - (data.fp_used || 0)
                ),
            });
            next.merge({
                player_cards: data.cards,
                game_free_cards: data.totalFreeCards,
            });
            postBalanceChange('local-action');
            payload.getAccountStatus();
        } else {
            meta.modals.errorBuy.merge({
                name: response.msg,
                isOpen: true,
            });
        }
    };

    socket.on('bingo:buyCards', callback);

    return () => {
        socket.off('bingo:buyCards', callback);
    };
};
